// extracted by mini-css-extract-plugin
export default {"content":"PopupConfirm_content__YrzgS"};